export default class PaymentType {

  id?: number;
  type: string = '';
  currency: string = '';

}